import styled, { css } from 'styled-components';
import { media, mixins } from '../../css';

export const StyledCarousel = styled.div`
  ${({ backgroundImage }) =>
    backgroundImage &&
    css`
      background-image: ${`url(${backgroundImage})`};
    `};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-color: ${({ backgroundColor }) => backgroundColor};

  overflow: hidden;
  && {
    .slider-control-bottomcenter {
      ${({ dotsUnder }) => (!dotsUnder ? 'bottom: 11% !important;' : null)};

      ${({ dotsUnder }) =>
        dotsUnder &&
        css`
          position: static !important;
          transform: translateX(0) !important;
        `};
      width: 100%;
      text-align: center;
    }
  }
`;

export const StyledCarouselButton = styled.button`
  border: 0;
  background: transparent;
  cursor: pointer;
  padding: ${mixins.pxToRem(10)};
  outline: 0;
`;

export const StyledPagingArrow = styled.button`
  ${media.lessThan('lg')`
    display: none;
  `};
  border: 0;
  background: transparent;
  cursor: pointer;
  outline: 0;
  ${(props) => (props.direction === 'left' ? `left: ${mixins.pxToRem(80)}` : `right: ${mixins.pxToRem(80)}`)};

  ${media.lessThan('xl')`
    ${(props) => (props.direction === 'left' ? `left: ${mixins.pxToRem(45)}` : `right: ${mixins.pxToRem(45)}`)};
  `};
  position: relative;
`;

export const StyledCarouselList = styled.ul`
  position: relative;
  margin: 0;
  height: auto;
  padding: 0;
`;
